import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.875 12.625L1.25 7M1.25 7L6.875 1.375M1.25 7H14.75",
		stroke: "black",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
